import { render } from "./CustomSteps.vue?vue&type=template&id=0f21b6f9"
import script from "./CustomSteps.vue?vue&type=script&lang=js"
export * from "./CustomSteps.vue?vue&type=script&lang=js"

import "./CustomSteps.vue?vue&type=style&index=0&id=0f21b6f9&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/common/infrastructure/componentes/base/common/controles/CustomSteps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f21b6f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f21b6f9', __exports__)) {
    api.reload('0f21b6f9', __exports__)
  }
  
  module.hot.accept("./CustomSteps.vue?vue&type=template&id=0f21b6f9", () => {
    api.rerender('0f21b6f9', render)
  })

}


export default __exports__